export default "__VITE_ASSET__6bc1911c__"